import React, { useState } from 'react';
import QuoteIcon from '../../assets/icons/QuoteIcon';
import DotsIcon from '../../assets/icons/DotsIcon';

interface TestimonialProps {
  text: string;
  author: string;
}

const Testimonial: React.FC<TestimonialProps> = ({ text, author }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="col mt-3">
      <div className="card shadow-sm mx-0">
        <div className="card-body pt-4 pb-3 position-relative">
          <QuoteIcon />
          <p
            className={`mb-0 pb-0 card-text ${expanded ? '' : 'clamp'}`}
            style={{ textIndent: '2em' }}
          >
            {text}
          </p>
          <div className="text-center">
            <button
              type="button"
              aria-label="expand testimonial"
              className="btn p-0 border-0 bg-transparent"
              onClick={() => setExpanded(!expanded)}
            >
              <DotsIcon />
            </button>
          </div>
          <footer>
            <hr className="mt-1 mb-2" />
            <h4 className="text-end">{author}</h4>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
